import { MoveGenerator } from '../../jscaip/AI/AI';
import { HiveMove } from './HiveMove';
import { HivePiece } from './HivePiece';
import { HiveRules } from './HiveRules';
export class HiveMoveGenerator extends MoveGenerator {
    getListMoves(node, _config) {
        const dropMoves = this.getListDrops(node.gameState);
        const movesOnBoard = this.getListOfOnBoardMoves(node.gameState);
        const moves = dropMoves.concat(movesOnBoard);
        if (moves.length === 0) {
            return [HiveMove.PASS];
        }
        return moves;
    }
    getListOfOnBoardMoves(state) {
        return HiveRules.get().getPossibleMovesOnBoard(state).toList();
    }
    getListDrops(state) {
        const drops = [];
        const player = state.getCurrentPlayer();
        const queenBee = new HivePiece(player, 'QueenBee');
        for (const coord of HiveRules.get().getPossibleDropLocations(state)) {
            if (HiveRules.get().mustPlaceQueenBee(state)) {
                drops.push(HiveMove.drop(queenBee, coord));
            }
            else {
                for (const remaining of state.remainingPieces.getPlayerPieces(state.getCurrentPlayer())) {
                    drops.push(HiveMove.drop(remaining, coord));
                }
            }
        }
        return drops;
    }
}
